<template>
  <v-footer dark height="auto">
    <v-row>
      <v-col cols="12" class="mt-2">
        <p class="text-center">&copy;{{ new Date().getFullYear() }} Divorce Pty Ltd
          for support email <a href="mailto:hello@divorceanswered.com.au">hello@divorceanswered.com.au</a>
        </p>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: [
      'fab fa-facebook',
      'fab fa-twitter',
      'fab fa-google-plus',
      'fab fa-linkedin',
      'fab fa-instagram'
    ]
  })
}
</script>
